import React from 'react';

export default class Code extends React.Component {
  constructor(){
    super();
    this.state={
    }
  }
  render() {
    return (
      <div>
        <textarea 
          style={
           { width:100+"%", height:30+"em" }
          }
           value={this.state.code} onChange={ (e)=>{
          this.props.hc(e.target.value);
        } }/>
      </div>);
  }
}

/*
LOAD =11
READ 1
ADD 1
WRITE =5555
WRITE 0
STORE 15
WRITE 15
HALT
*/


// WEBPACK FOOTER //
// ./components/Code.jsx